import isEmbedded from 'utils/is-embedded';

export default function useIsEmbedded() {
  return isEmbedded();
}
